import Textbox from '@stories/Components/Inputs/Textbox/Textbox';
import * as React from 'react';
import FS from '../FieldShared.styles';
const TextField = ({ dirty, error, inputProps, label, type = 'text', readOnly = false, placeholder, required, onChange, description, maxLength, }) => {
    return (React.createElement(FS.Container, { "data-text": true, "data-type": type, "data-dirty": dirty, "data-valid": dirty && !error, "data-invalid": dirty && !!error },
        React.createElement(FS.Label, { htmlFor: inputProps.name },
            label,
            required ? '*' : ''),
        React.createElement(Textbox, { ...inputProps, onChange: (e) => {
                if (onChange) {
                    onChange(e);
                }
                else if (inputProps.onChange) {
                    inputProps.onChange(e);
                }
            }, id: inputProps.name, type: type, placeholder: placeholder, readOnly: readOnly, maxLength: maxLength, hasError: error ? true : false }),
        description && React.createElement(FS.Description, null, description),
        error && React.createElement(FS.Error, null, error.message)));
};
export default TextField;
